export default __webpack_public_path__ + "media/images/document-dossier-g162-papier-rouge-icone-9726-96-d1ce4ede0d6ad6faeea2a73fc65291bb.png";